import LegalDocumentPage from '@/components/legal/LegalDocumentPage';

export default function PrivacyPage() {
  return <LegalDocumentPage documentKey="privacy" headingId="privacy-page-heading" />;
}
